/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpenseBatchStatus } from './';
import {
    ExpenseBatchStatusFromJSON,
    ExpenseBatchStatusFromJSONTyped,
    ExpenseBatchStatusToJSON,
} from './';
import type { ExpenseFreelancerPaymentStatus } from './';
import {
    ExpenseFreelancerPaymentStatusFromJSON,
    ExpenseFreelancerPaymentStatusFromJSONTyped,
    ExpenseFreelancerPaymentStatusToJSON,
} from './';
import type { ExpenseResource } from './';
import {
    ExpenseResourceFromJSON,
    ExpenseResourceFromJSONTyped,
    ExpenseResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseBatchResource
 */
export interface ExpenseBatchResource {
    /**
     * 
     * @type {string}
     * @memberof ExpenseBatchResource
     */
    expenseBatchId: string;
    /**
     * 
     * @type {ExpenseBatchStatus}
     * @memberof ExpenseBatchResource
     */
    status: ExpenseBatchStatus;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseBatchResource
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseBatchResource
     */
    approvedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseBatchResource
     */
    clientPaidDate?: Date;
    /**
     * 
     * @type {ExpenseFreelancerPaymentStatus}
     * @memberof ExpenseBatchResource
     */
    freelancerPaymentStatus: ExpenseFreelancerPaymentStatus;
    /**
     * 
     * @type {Array<ExpenseResource>}
     * @memberof ExpenseBatchResource
     */
    expenses: Array<ExpenseResource>;
}

/**
 * Check if a given object implements the ExpenseBatchResource interface.
 */
export function instanceOfExpenseBatchResource(value: object): value is ExpenseBatchResource {
    if (!('expenseBatchId' in value) || value['expenseBatchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('freelancerPaymentStatus' in value) || value['freelancerPaymentStatus'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    return true;
}

export function ExpenseBatchResourceFromJSON(json: any): ExpenseBatchResource {
    return ExpenseBatchResourceFromJSONTyped(json, false);
}

export function ExpenseBatchResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseBatchResource {
    if (json == null) {
        return json;
    }
    return {
        
        'expenseBatchId': json['expenseBatchId'],
        'status': ExpenseBatchStatusFromJSON(json['status']),
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'approvedDate': json['approvedDate'] == null ? undefined : (new Date(json['approvedDate'])),
        'clientPaidDate': json['clientPaidDate'] == null ? undefined : (new Date(json['clientPaidDate'])),
        'freelancerPaymentStatus': ExpenseFreelancerPaymentStatusFromJSON(json['freelancerPaymentStatus']),
        'expenses': ((json['expenses'] as Array<any>).map(ExpenseResourceFromJSON)),
    };
}

export function ExpenseBatchResourceToJSON(value?: ExpenseBatchResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expenseBatchId': value['expenseBatchId'],
        'status': ExpenseBatchStatusToJSON(value['status']),
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'approvedDate': value['approvedDate'] == null ? undefined : ((value['approvedDate']).toISOString()),
        'clientPaidDate': value['clientPaidDate'] == null ? undefined : ((value['clientPaidDate']).toISOString()),
        'freelancerPaymentStatus': ExpenseFreelancerPaymentStatusToJSON(value['freelancerPaymentStatus']),
        'expenses': ((value['expenses'] as Array<any>).map((v) => ExpenseResourceToJSON(v))),
    };
}

